export default {
    name: 'testimonialSection',
    title: 'Testimonial Section',
    type: 'document',
    fields: [
        { name: 'testimonial', title: 'Testimonial', type: 'text', validation: Rule => Rule.required() },
        { name: 'author', title: 'Author', type: 'string', validation: Rule => Rule.required() }
    ],
    preview: {
        prepare() {
            return {
                title: 'Testimonial Section',
                subtitle: 'Homepage testimonial section'
            }
        }
    }

} 